import { render, staticRenderFns } from "./ExcludeProductList.vue?vue&type=template&id=b1be060c&scoped=true"
import script from "./ExcludeProductList.vue?vue&type=script&lang=js"
export * from "./ExcludeProductList.vue?vue&type=script&lang=js"
import style0 from "./ExcludeProductList.vue?vue&type=style&index=0&id=b1be060c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1be060c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1be060c')) {
      api.createRecord('b1be060c', component.options)
    } else {
      api.reload('b1be060c', component.options)
    }
    module.hot.accept("./ExcludeProductList.vue?vue&type=template&id=b1be060c&scoped=true", function () {
      api.rerender('b1be060c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal/product-score-rules/form/ExcludeProductList.vue"
export default component.exports